import * as React from 'react';
import CurrencyQuery from '../../Query/Currencies';
import PricesWithDiscountInputControl, { IPricesWithDiscountInputControlProps } from './PricesWithDiscountInput';

class PricesWithDiscountInput extends React.Component<IPricesWithDiscountInputControlProps> {

  public render() {
    return (
      <CurrencyQuery>
        {({ currencies, availabilityMode }: any) => {
          if (currencies && !currencies.loading && currencies.currencies) {
            return (
              <PricesWithDiscountInputControl
                availabilityMode={availabilityMode}
                {...this.props}
                currencies={currencies.currencies}
              />
            );
          }
          return null;
        }}
      </CurrencyQuery>
    );
  }
}

export default PricesWithDiscountInput;


// WEBPACK FOOTER //
// ./src/components/Others/PricesWithDiscountInput/index.tsx